/**
 *
 * @param name name of the localstorage
 * @returns string
 */

const defaultExpiry = 60 * 60; // one hour
const expiresKey = "_expiresIn";

export const getLocalStorage = (name: string) => {
    const now = Date.now();
    const expiresIn = parseInt(localStorage.getItem(name + expiresKey) || "0");

    if (expiresIn < now) {
        removeLocalStorage(name);
        return null;
    } else {
        try {
            const value = localStorage.getItem(name);
            return value;
        } catch (e) {
            console.log(
                `Error reading ${name} from localstorage ${JSON.stringify(e)}`
            );
            return null;
        }
    }
};

/**
 * setLocalStorage : create a local storage with name and value, and set the expiry.
 * @param name localstorage name
 * @param value localstorage value
 * @param expires ttl in seconds for the localstorage
 * @returns boolean
 */
export const setLocalStorage = (
    name: string,
    value: string,
    expires = defaultExpiry
) => {
    expires = Math.abs(expires);

    const now = Date.now();
    const schedule = now + expires * 1000;
    try {
        localStorage.setItem(name, value);
        localStorage.setItem(name + expiresKey, schedule.toString());
    } catch (e) {
        console.log(
            `Error setting ${name} in localstorage ${JSON.stringify(e)}`
        );
        return false;
    }
    return true;
};

/**
 *
 * @param name localstorage name
 * @returns boolean
 */
export const removeLocalStorage = (name: string) => {
    try {
        localStorage.removeItem(name);
        localStorage.removeItem(name + expiresKey);
    } catch (e) {
        console.log(
            `Error removing ${name} in localstorage ${JSON.stringify(e)}`
        );
        return false;
    }
    return true;
};
